export default {
    baseStyle: {
        // General Payment Container
        '.payment .adyen-checkout__dropin': {
            padding: '0 0 32px 0'
        },

        // Payment Method (Common)
        '.payment .adyen-checkout__payment-method': {
            border: 0,
            backgroundColor: 'white'
        },
        '.payment .adyen-checkout__payment-method__name': {
            textTransform: 'uppercase',
            fontWeight: 700,
        },
        '.payment .adyen-checkout__payment-method__header': {
            padding: 0,
            fontSize: '14px'
        },
        '.payment .adyen-checkout__payment-method__radio': {
            width: '18px',
            height: '18px',
            backgroundColor: 'white',
            border: '1px solid black',
            order: 1,
            '&::after': {
                backgroundColor: 'black',
                top: '8px',
                width: '12px',
                height: '12px',
            }
        },
        '.payment .adyen-checkout__payment-method__brands': {
            display: 'none'
        },
        '.payment .adyen-checkout__payment-method__image__wrapper': {
            order: 3,
            boxShadow: 'none',
            width: '90px',
            height: '29px',
            justifyContent: 'flex-start'
        },
        '.adyen-checkout__payment-method--scheme .adyen-checkout__payment-method__image__wrapper': {
            '&::after': {
                content: '""',
                display: 'block',
                background: `url("data:image/svg+xml,%3Csvg%20width%3D%2289%22%20height%3D%2218%22%20viewBox%3D%220%200%2089%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%3E%3Crect%20x%3D%2262%22%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%2262.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M88.74%2013.35V15.306H86.256L85.338%2014.232L84.384%2015.306H77.328V9.588H75L77.91%203H80.742L81.426%204.494V3H84.942L85.53%204.566L86.106%203H88.74V3.92999H86.706L85.782%206.36601L85.536%207.02599L84.354%203.92999H82.32V8.72998L80.208%203.92999H78.57L76.446%208.72998H77.838L78.21%207.806H80.538L80.91%208.72998H82.32H83.544V5.604L83.538%204.97399L83.778%205.604L84.948%208.72998H86.112L87.288%205.604L87.516%204.98V8.72998H88.74V10.608L87.384%2011.97L88.74%2013.35ZM78.312%2014.376V9.59397H82.32V10.632H79.536V11.472H82.266V12.504H79.536V13.338H82.32V14.376H78.312ZM88.368%2014.376H86.778L85.326%2012.816L83.868%2014.376H82.32L84.558%2011.994L82.32%209.59397H83.916L85.356%2011.148L86.802%209.59397H88.368L86.124%2011.976L88.368%2014.376Z%22%20fill%3D%22%23016FD0%22/%3E%3Cpath%20d%3D%22M79.374%204.95599L79.134%205.55601L78.636%206.76798H80.112L79.614%205.55601L79.374%204.95599Z%22%20fill%3D%22%23016FD0%22/%3E%3Crect%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%220.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20d%3D%22M16.6781%205.48633C15.187%205.48633%2013.8545%206.25918%2013.8545%207.68709C13.8545%209.32464%2016.2177%209.43774%2016.2177%2010.2604C16.2177%2010.6068%2015.8208%2010.9169%2015.1428%2010.9169C14.1806%2010.9169%2013.4614%2010.4836%2013.4614%2010.4836L13.1537%2011.9245C13.1537%2011.9245%2013.9822%2012.2905%2015.0821%2012.2905C16.7123%2012.2905%2017.9951%2011.4797%2017.9951%2010.0274C17.9951%208.297%2015.622%208.18725%2015.622%207.42369C15.622%207.15235%2015.9479%206.85504%2016.6239%206.85504C17.3867%206.85504%2018.009%207.17014%2018.009%207.17014L18.3102%205.77845C18.3102%205.77845%2017.633%205.48633%2016.6781%205.48633ZM3.03611%205.59136L3%205.80143C3%205.80143%203.6273%205.91623%204.19229%206.14525C4.91975%206.40785%204.97158%206.56073%205.09409%207.03556L6.42916%2012.1822H8.21882L10.9759%205.59136H9.19037L7.41876%2010.0725L6.69584%206.27407C6.62954%205.83935%206.29372%205.59136%205.88266%205.59136H3.03611ZM11.6939%205.59136L10.2932%2012.1822H11.9959L13.3917%205.59136H11.6939ZM21.1904%205.59136C20.7798%205.59136%2020.5623%205.81118%2020.4026%206.1953L17.9081%2012.1822H19.6937L20.0391%2011.1844H22.2144L22.4245%2012.1822H24L22.6255%205.59136H21.1904ZM21.4226%207.372L21.9519%209.84519H20.5339L21.4226%207.372Z%22%20fill%3D%22%231434CB%22/%3E%3Crect%20x%3D%2231%22%20width%3D%2227%22%20height%3D%2218%22%20rx%3D%222%22%20fill%3D%22white%22/%3E%3Crect%20x%3D%2231.5%22%20y%3D%220.5%22%20width%3D%2226%22%20height%3D%2217%22%20rx%3D%221.5%22%20stroke%3D%22black%22%20stroke-opacity%3D%220.2%22/%3E%3Cpath%20d%3D%22M42.2021%204.81641H46.7987V13.0756H42.2021V4.81641Z%22%20fill%3D%22%23FF5F00%22/%3E%3Cpath%20d%3D%22M42.4936%208.94658C42.4936%207.26847%2043.2815%205.78006%2044.4927%204.81697C43.6026%204.11654%2042.479%203.69336%2041.2532%203.69336C38.3494%203.69336%2036%206.04272%2036%208.94658C36%2011.8504%2038.3494%2014.1998%2041.2532%2014.1998C42.479%2014.1998%2043.6026%2013.7766%2044.4927%2013.0762C43.2815%2012.1277%2042.4936%2010.6247%2042.4936%208.94658Z%22%20fill%3D%22%23EB001B%22/%3E%3Cpath%20d%3D%22M52.9995%208.94658C52.9995%2011.8504%2050.6502%2014.1998%2047.7463%2014.1998C46.5206%2014.1998%2045.397%2013.7766%2044.5068%2013.0762C45.7326%2012.1131%2046.506%2010.6247%2046.506%208.94658C46.506%207.26847%2045.718%205.78006%2044.5068%204.81697C45.397%204.11654%2046.5206%203.69336%2047.7463%203.69336C50.6502%203.69336%2052.9995%206.05731%2052.9995%208.94658Z%22%20fill%3D%22%23F79E1B%22/%3E%3C/svg%3E") no-repeat center center/89px`,
                top: '2px',
                width: '90px',
                height: '29px',
                position: 'absolute'
            }
        },
        '.adyen-checkout__payment-method--scheme .adyen-checkout__payment-method__image': {
            visibility: 'hidden'
        },
        '.payment .adyen-checkout__payment-method__image': {
            transform: 'scale(1.8)',
            width: '70px'
        },
        '.payment .adyen-checkout__payment-method__name_wrapper': {
            order: 2
        },
        '.payment .adyen-checkout__store-details': {
            border: 0,
            paddingLeft: 0
        },
        '.payment .adyen-checkout__store-details .adyen-checkout__checkbox__label': {
            '&::after': {
                borderRadius: 0
            }
        },
        '.payment .adyen-checkout__card__brands': {
            display: 'none'
        },
        '.payment .adyen-checkout__field--cardNumber': {
            '@media (min-width: 992px)': {
                width: '343px',
            }
        },
        '.payment .adyen-checkout__field-wrapper': {
            '@media (min-width: 992px)': {
                width: '343px',
            }
        },

        // Klarna Specific Styles
        '.has-gc .adyen-checkout__payment-method--klarna': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc-products .adyen-checkout__payment-method--klarna': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaProductMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc .adyen-checkout__payment-method--klarna_account': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.has-gc-products .adyen-checkout__payment-method--klarna_account': {
            position: 'relative',
            pointerEvents: 'none',
            '&::before': {
                content: '""',
                position: 'absolute',
                left: 0,
                right: 0,
                bottom: 0,
                top: 0,
                background: 'alternativeWarning.200',
                zIndex: 1000,
            },
            '&::after': {
                content: 'var(--klarnaProductMessage)',
                background: 'alternativeWarning.100',
                zIndex: 100000021,
                position: 'relative',
                display: 'block',
                padding: '16px',
                margin: '20px 4px 4px 4px',
                color: 'warningText',
                pointerEvents: 'none',
                fontSize: '12px'
            }
        },
        '.adyen-checkout__payment-method--klarna .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.adyen-checkout__payment-method--klarna .adyen-checkout__button__text': {
            whiteSpace: 'break-spaces'
        },
        '.adyen-checkout__payment-method--klarna_account .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },

        // PayPal Specific Styles
        '.adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout__paypal__buttons': {
            '@media (min-width: 992px)': {
                maxWidth: '343px',
            }
        },
        '.payment .adyen-checkout__payment-method--paypal .adyen-checkout__payment-method__image': {
            transform: 'scale(1)',
            width: '40px'
        },

        // Apple Pay Specific Styles
        '.adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__name_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout__payment-method--applepay .adyen-checkout__payment-method__image': {
            transform: 'scale(1)',
            width: '45px'
        },
        'apple-pay-button': {
            display: 'block',
            '--apple-pay-button-height': '48px',
            '--apple-pay-button-border-radius': '0',
            '@media (min-width: 992px)': {
                maxWidth: '343px',
                '--apple-pay-button-width': '343px'
            }
        },

        // Input and Field Styling
        '.payment .adyen-checkout__input-wrapper': {
            fontFamily: 'HelveticaNeueLTStd-Form',
            borderTop: 0,
            borderRight: 0,
            borderBottom: '1px solid gray.800',
            borderLeft: 0,
            borderRadius: 0,
            boxShadow: 'none !important'
        },
        '.payment .adyen-checkout__input': {
            paddingLeft: 0
        },
        '.payment .adyen-checkout__payment-method__details': {
            padding: 0
        },
        '.payment .adyen-checkout__payment-method__details__content': {
            marginTop: '20px'
        },
        '.payment .adyen-checkout__label__text': {
            display: 'none'
        },

        // Submit Button
        '.payment .adyen-checkout__button ': {
            borderRadius: 0,
            backgroundColor: 'black',
            textTransform: 'uppercase',
            '@media (min-width: 992px)': {
                minWidth: '343px',
                width: 'auto',
                padding: '0 30px',
            }
        },

        // Card Specific Adjustments
        '.payment .adyen-checkout__card__cardNumber__brandIcon': {
            display: 'none'
        },
        '.payment .adyen-checkout__card__form': {
            '@media (min-width: 992px)': {
                width: '343px'
            }
        },
        '.payment .adyen-checkout__card__holderName': {
            '@media (min-width: 992px)': {
                width: '343px'
            }
        },

        // Hiding Miscellaneous Elements
        '.payment .adyen-checkout-form-instruction': {
            display: 'none'
        },
        '.payment .adyen-checkout__field__exp-date_hint_wrapper': {
            display: 'none'
        },
        '.payment .adyen-checkout-contextual-text': {
            display: 'none'
        },

        // Saved CC Specific Styles
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__image':
            {
                transform: 'scale(0.7)',
                width: '45px',
                height: '100%',
                visibility: 'visible'
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__image__wrapper':
            {
                width: '40px',
                '&::after': {
                    display: 'none'
                }
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__payment-method__name_wrapper':
            {
                order: 3
            },
        '.payment .adyen-checkout__payment-methods-list--storedPayments .adyen-checkout__field--inactive':
            {
                pointerEvents: 'none'
            }
    }
}
